<!-- app -->
<template>
   <div id="loader"></div>
   <DevGrid v-if="isDev" />
   <!-- <NuxtLoadingIndicator /> -->
   <LazyHeader />

   <main id="universe">
      <NuxtLayout>
         <NuxtPage :key="route.path" />
      </NuxtLayout>
   </main>
   <!-- <Lenis
      id="universe"
      :options="{ prevent: (node) => node.classList.contains('pm') }"
   >
      <NuxtLayout>
         <NuxtPage :key="route.path" />
      </NuxtLayout>
   </Lenis> -->
   <LazyToast :toastsList="toastsList" />
   <!-- <LazyModalsOnboarding v-if="onboardingNeeded" :open="onboardingNeeded" /> -->
   <!-- Client-only so its teleport can't swap SSR order with a page's modal in #teleports -->
   <ClientOnly>
      <LazyGlobalModal />
   </ClientOnly>
   <div id="modals"></div>
   <LazyFooter />
   <LazyRefreshApp />
   <!-- CookieConsent is now handled by plugins/cookie-consent.client.ts -->
   <!-- <LazyNuxtCookieConsentPolicy /> -->
   <!-- <LazyGDPRAlert /> -->
</template>

<script setup>
import apercuRegular from "~/assets/fonts/Apercu-Regular.woff2?url";
import adelleRegular from "~/assets/fonts/Adelle-Regular.woff2?url";

const route = useRoute();

// ?url resolves to the same hashed file fonts.scss loads, so the preload is actually used.
useHead({
   link: [apercuRegular, adelleRegular].map((href) => ({
      rel: "preload",
      href,
      as: "font",
      type: "font/woff2",
      crossorigin: "",
   })),
});
// const authedStore = useAuthStore();
// const { getAuthed, getUser } = storeToRefs(authedStore);
// const { queryOnboardingCourses } = usePd();
const { toastsList } = useToast();
const isDev = process.dev;

// const onboardingNeeded = computed(() => {
//    // logInfo("Onboarding needed:", getAuthed.value, getUser.value);
//    return getAuthed.value == true && !getUser.value?.is_onboarding_completed;
// });

// if (onboardingNeeded.value) {
//    // logInfo("Onboarding needed, fetching courses from APP...");
//    await useAsyncData("onboarding-courses", queryOnboardingCourses);
// }
const $config = useRuntimeConfig();
onMounted(() => {
   console.log(
      `------------    ${$config.public.buildVersion}    ------------`,
   );
});
// GET ALL CLASSES
// await useAsyncData("users-classes", () => queryClasses());
</script>

<style lang="scss"></style>
